<template>
  <div class="container-fluid">
  <Navbar></navbar>
    <h1>{{ $t('login') }}</h1>
    
    <button @click="lang('de')">German</button>
    <button @click="lang('en')">English</button>
    
    <router-link to="/posts">Posts</router-link>
    
    <form v-on:submit.prevent="login">
		<div>
    		<label for="email">{{ $t('form.email') }}</label>
			<input type="text" v-model="email" id="email" v-translate:placeholder="'form.placeholder.email'">
		</div>
    
    	<div>
    		<label for="password">{{ $t('form.password') }}</label>
			<input type="password" v-model="password" id="password" v-translate:placeholder="'form.placeholder.password'">
		</div>
		<button type="submit">{{ $t('login') }}</button>
    </form>
  </div>
</template>

<script>
import Navbar from './global/TopFixedNavbar'
import eaw from 'endless-api-wrapper';

export default {
  name: 'Login',
  data () {
    return {
      password: "",
      email: ""
    }
  },
  methods: {
		login: function(e) {
			console.log("submit")
			const email = this.email
			const password = this.password
			const that = this
			this.$store.dispatch('LOGIN', {
				email,
				password
			}).then(function(res) {
				if(that.$route.query.auth) {
					//TODO get url for id from api
					const jwt = res
					eaw.applications.getMeta({application_id: that.$route.query.auth}).then((res) => {
						console.log(jwt)
						console.log(res)
						if(res.data.callbackUrl) {
							console.log(`${res.data.callbackUrl}?jwt=${jwt}`)
							window.location.href=`${res.data.callbackUrl}?jwt=${jwt}`
						}
					})
				} else {
					that.$router.push(that.$route.query.redirect?that.$route.query.redirect:'/')
				}
			})
		},
		lang (lang) {
			this.$store.dispatch("translations/UPDATE_TRANSLATIONS", lang)
		}
  },
  components: {
    Navbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container-fluid {
	padding: 1.5rem;
	box-sizing: border-box;
}

INPUT {
	border: 1px solid rgba(166,166,166,0.6);
	display: block;
	width: 100%;
	line-height: 1.5;
	font-size: 1rem;
	border-radius: .25rem;
	box-sizing: border-box;
	padding-right: 5px;
    padding-left: 5px;
}

FORM > div {
	box-sizing: border-box;
	margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue